import { ArnValidErc721NftConfig, ArnValidNftConfig } from '@arianee/arn-types';

export type ArnNftErc721Config = Partial<ArnValidErc721NftConfig>;

export interface ArnNftConfig {
  list?: {
    url: string;
  };
  erc721?: ArnNftErc721Config;
}

export class ArnNftConfigImpl implements ArnValidNftConfig {
  constructor(
    readonly list: {
      url: string;
    },
    readonly erc721: ArnValidErc721NftConfig
  ) {}
}
